var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "barra-carteira" },
    [
      !_vm.switchVisualizacao
        ? _c(
            "v-row",
            { staticClass: "linha line-barra-carteira" },
            [
              _c(
                "v-col",
                { staticClass: "coluna", attrs: { md: "2", xs: "12" } },
                [
                  _c("div", { staticClass: "descricao title-desc" }, [
                    _c("span", [_vm._v(" Carteira ")]),
                    _c("div", [
                      _c(
                        "label",
                        {
                          attrs: {
                            title: "gross-up",
                            "aria-details": "gross-up"
                          }
                        },
                        [
                          _c("input", {
                            attrs: { type: "checkbox", id: "mobGUCB" },
                            on: { click: _vm.changeGrossUp }
                          }),
                          _vm._v("  gross up ")
                        ]
                      )
                    ])
                  ])
                ]
              ),
              _c(
                "v-col",
                { staticClass: "coluna", attrs: { md: "1", xs: "12" } },
                [
                  _c("div", { staticClass: "descricao hide" }, [
                    _c("span", [_vm._v(" 100% ")])
                  ])
                ]
              ),
              _c(
                "v-col",
                { staticClass: "coluna", attrs: { md: "2", xs: "12" } },
                [_c("div", { staticClass: "descricao hide" }, [_c("span")])]
              ),
              _c(
                "v-col",
                { staticClass: "coluna", attrs: { md: "2", xs: "12" } },
                [_c("div", { staticClass: "descricao hide" }, [_c("span")])]
              ),
              _c(
                "v-col",
                { staticClass: "coluna", attrs: { md: "1", xs: "12" } },
                [_c("div", { staticClass: "descricao hide" }, [_c("span")])]
              ),
              _c(
                "v-col",
                { staticClass: "coluna", attrs: { md: "2", xs: "12" } },
                [_c("div", { staticClass: "descricao hide" }, [_c("span")])]
              ),
              _c(
                "v-col",
                {
                  staticClass: "coluna",
                  attrs: { md: "2", xs: "12", title: _vm.evoTotal.saldo }
                },
                [
                  _c("div", { staticClass: "descricao" }, [
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.currencyHelper.formatValue(_vm.evoTotal.saldo)
                          ) +
                          " "
                      )
                    ])
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.switchVisualizacao
        ? _c(
            "v-row",
            { staticClass: "linha-2" },
            [
              _c(
                "v-col",
                { staticClass: "coluna", attrs: { md: "2", xs: "12" } },
                [
                  _c("div", { staticClass: "descricao" }, [
                    _c("span", [_vm._v(" Carteira")]),
                    _c("div", [
                      _c(
                        "label",
                        {
                          attrs: {
                            title: "gross-up",
                            "aria-details": "gross-up"
                          }
                        },
                        [
                          _c("input", {
                            attrs: { type: "checkbox", id: "screenGUCB" },
                            on: { click: _vm.changeGrossUp }
                          }),
                          _vm._v(" gross up ")
                        ]
                      )
                    ])
                  ])
                ]
              ),
              _c(
                "v-col",
                {
                  staticClass: "coluna",
                  attrs: { md: "1", xs: "12", title: _vm.evoTotal.saldo }
                },
                [
                  _c("div", [
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.currencyHelper.formatValue(_vm.evoTotal.saldo)
                          ) +
                          " "
                      )
                    ])
                  ])
                ]
              ),
              _c(
                "v-col",
                {
                  staticClass: "coluna coluna-composta",
                  attrs: { md: "3", xs: "12" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "colunas" },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "hide column",
                              attrs: {
                                md: "3",
                                xs: "12",
                                title: _vm.evoTotal.mensal.ganho * 100
                              }
                            },
                            [
                              _c("div", {}, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.bound
                                        ? "---"
                                        : _vm.percentageHelper.formatPercentage(
                                            _vm.evoTotal.mensal.ganho
                                          )
                                    )
                                  )
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "hide column",
                              attrs: {
                                md: "3",
                                xs: "12",
                                title: _vm.evoTotal.mensal.percentual * 100
                              }
                            },
                            [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.bound
                                        ? "---"
                                        : _vm.percentageHelper.formatPercentage(
                                            _vm.evoTotal.mensal.percentual
                                          )
                                    )
                                  )
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "hide column",
                              attrs: {
                                md: "6",
                                xs: "12",
                                title: _vm.evoTotal.mensal.valor
                              }
                            },
                            [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.bound
                                        ? "---"
                                        : _vm.currencyHelper.formatValue(
                                            _vm.evoTotal.mensal.valor
                                          )
                                    )
                                  )
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  staticClass: "coluna coluna-composta",
                  attrs: { md: "3", xs: "12" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "colunas" },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "hide column",
                              attrs: {
                                md: "3",
                                xs: "12",
                                title: _vm.evoTotal.doze.ganho * 100
                              }
                            },
                            [
                              _c("div", {}, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.bound
                                        ? "---"
                                        : _vm.percentageHelper.formatPercentage(
                                            _vm.evoTotal.doze.ganho
                                          )
                                    )
                                  )
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "hide column",
                              attrs: {
                                md: "3",
                                xs: "12",
                                title: _vm.evoTotal.doze.percentual * 100
                              }
                            },
                            [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.bound
                                        ? "---"
                                        : _vm.percentageHelper.formatPercentage(
                                            _vm.evoTotal.doze.percentual
                                          )
                                    )
                                  )
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "hide column",
                              attrs: {
                                md: "6",
                                xs: "12",
                                title: _vm.evoTotal.doze.valor
                              }
                            },
                            [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.bound
                                        ? "---"
                                        : _vm.currencyHelper.formatValue(
                                            _vm.evoTotal.doze.valor
                                          )
                                    )
                                  )
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "v-col",
                {
                  staticClass: "coluna coluna-composta",
                  attrs: { md: "3", xs: "12" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "colunas" },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "hide column",
                              attrs: {
                                md: "3",
                                xs: "12",
                                title: _vm.evoTotal.geral.ganho * 100
                              }
                            },
                            [
                              _c("div", {}, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.percentageHelper.formatPercentage(
                                        _vm.evoTotal.geral.ganho
                                      )
                                    )
                                  )
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "hide column",
                              attrs: {
                                md: "3",
                                xs: "12",
                                title: _vm.evoTotal.geral.percentual * 100
                              }
                            },
                            [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.percentageHelper.formatPercentage(
                                        _vm.evoTotal.geral.percentual
                                      )
                                    )
                                  )
                                ])
                              ])
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "hide column",
                              attrs: {
                                md: "6",
                                xs: "12",
                                title: _vm.evoTotal.geral.valor
                              }
                            },
                            [
                              _c("div", [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.currencyHelper.formatValue(
                                        _vm.evoTotal.geral.valor
                                      )
                                    )
                                  )
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }